import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import {
  Grid, Box, Button, Typography, FormControl
} from '@mui/material';
import { mapStateToProps } from "../../../redux/reducers";
import { connect } from "react-redux";
import * as actionType from "../../../redux/actionTypes/csaSignup";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import SelectDropdown from "../../common/selectdropdown-component";
import { useParams} from "react-router-dom";
import CommonLoading from '../../common/components/commonLoading';
import SelectDropdown from '../../../components/SelectDropdown';

function FarmInfocomponent(props) {
  let { vendorId, vendorNam } = useParams();
  // const [searchParams] = useSearchParams();
  // let mapVendorId = searchParams.get("vendorId");
  const [language, setLanguage] = useState({});
  vendorId = props?.farmInfo?.farmDetails?.vendorId ? props?.farmInfo?.farmDetails?.vendorId : (vendorId ? vendorId : "");
  const [csaVendorList, setCsaVendorList] = useState([]);
  const [csaVendorInfo, setCsaVendorInfo] = useState({});
  const [selectedVendor, setSelectedVendor] = useState(props?.farmInfo?.farmDetails ? {name: props?.farmInfo?.farmDetails?.farmName, label:props?.farmInfo?.farmDetails?.farmName,id:props?.farmInfo?.farmDetails?.vendorId,isHIPVendor:props?.farmInfo?.farmDetails?.isHIPVendor} :  { name: "", label:  `--${props?.signupLanguage?.select}--` });
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setLanguage(props.signupLanguage)
  }, [props.signupLanguage]);

  useEffect(() => {
    if (props.csaSignup?.csaVendorList?.csaVendorList?.length == 0) {
      props.getCsaVendorList();
    }
    props.setVendorChange(false);
  }, []);
   
  // eslint-disable-next-line no-unused-vars
  const buttonDisable = (Object.keys(csaVendorInfo).length <= 0)

  useEffect(() => {
    setIsLoading(false);
    if (props.csaSignup?.csaVendorList?.csaVendorList?.length) { 
      if (vendorId) {   
        const selectedVdr = props.csaSignup?.csaVendorList?.csaVendorList.find(item=>item.vendorId == vendorId);      
        if (selectedVdr) {
          const obj = {
            name: selectedVdr?.vendorName,
            values: selectedVdr?.vendorName,
            id: selectedVdr?.vendorId,
            isHIPVendor: selectedVdr?.isHIPVendor
          }
          setSelectedVendor(obj);
          props.getVendorInfo({ vendorId : parseInt(vendorId)});
        }
      }
      const vendorList = props.csaSignup?.csaVendorList?.csaVendorList.map((item) => {
        return {
          name: item?.vendorName,
          values: item?.vendorName,
          id: item?.vendorId,
          isHIPVendor: item?.isHIPVendor
        };
      });
      setCsaVendorList(vendorList);
    } 
  }, [vendorId,props.csaSignup?.csaVendorList]);

  useEffect(() => {
    setCsaVendorInfo(props.csaSignup?.csaVendorInfo?.csaVendorInfo && Object.keys(props.csaSignup?.csaVendorInfo?.csaVendorInfo).length ? props.csaSignup?.csaVendorInfo?.csaVendorInfo : {});
    setIsLoading(false);
  }, [props.csaSignup?.csaVendorInfo]);

  useEffect(() => {
    if (props?.farmInfo?.farmDetails) {
      setSelectedVendor({
        name: props.farmInfo.farmDetails.farmName,
        label: props.farmInfo.farmDetails.farmName,
        id: props.farmInfo.farmDetails.vendorId,
        isHIPVendor: props.farmInfo.farmDetails.isHIPVendor,
      });
    } else {
      setSelectedVendor({ name: "", label: `--${props?.signupLanguage?.select}--` });
    }
    setCsaVendorInfo({});
  }, [props?.farmInfo?.farmDetails]);
  return (
    <Grid item lg={12} md={12} ml={4} className='wrapper-gird' sx={{ mt: 7.2}}>
      <Box>
          {isLoading && <CommonLoading />}
        <Box sx={{ backgroundColor: '#EEEEEE', border: '1px solid #CCCCCC' }}>
          <Typography variant="h3" className='sub-heading'>
            {language.farmInfo}
          </Typography>
        </Box>
        <Grid container item xs={12} sx={{ border: '1px solid #CCCCCC', borderTop: 'none', minHeight: '10rem' }} >
          <Grid container sx={{m:2}}>
            <Grid container item xs={12} sm={12} md={12} lg={7} xl={7}  direction={'column'}>
              {isError && (<span className='dh-txt-danger'role="alert" aria-live="assertive"><i className="fa fa-info-circle"></i> {language.farmError}</span>)}
              <Grid item xs={6} lg={6} md={6}>
                <p>Fields marked with a asterisk <span className="ads-asterisk" aria-hidden="true">*</span> are required.</p>	
                <FormControl sx={{ mt: 1, width: "90%",height:'auto' }} >
                  <Typography  component={"label"} sx={{ mb: "10px", fontFamily: 'texta-bold', fontSize: '1.25rem' }}>
                    {language.chooseFarm} <span className="sr-only">required</span><span aria-hidden="true">*</span>
                  </Typography>
                  <SelectDropdown
                    label={"Choose Farm"}
                    defaultValue={selectedVendor}
                    disabled={vendorNam?.trim() ? true : false}
                    onChange={e => {
                      props.getVendorInfo({ vendorId: e.id });
                      props.setVendorChange(true);
                      setSelectedVendor(e);
                      setIsError(false);
                      setIsLoading(true);
                    }}
                    dataList={csaVendorList}
                    // isSearch={true}
                    // defaultValueProps={{
                    //   default: true                   
                    // }}
                  />
                </FormControl>
              
                {Object.keys(csaVendorInfo).length > 0 && csaVendorInfo?.products && (
                  <Box pt={2} >
                    <Typography  variant='h4' sx={{ mb: "10px", fontFamily: 'Texta-bold', fontSize: '1.25rem'}}>{language["Notes about our CSA"]}
                    </Typography>
                    <Typography component={'p'} sx={{ mb: "10px", fontSize: "1.25rem", fontFamily:"Texta-book, Helvetica, Arial, 'sans-serif'"}}>
                      {csaVendorInfo?.products}
                    </Typography>
                  </Box>
                )}
                {Object.keys(csaVendorInfo).length > 0 && csaVendorInfo?.publicWebsite && (
                  <Box pt={2}>
                    <Typography variant='h4' sx={{ mb: "10px", fontFamily: 'Texta-bold', fontSize: '1.25rem'}}>{language.Website}
                    </Typography>
                    <Typography component={'p'} sx={{ mb: "10px", fontSize: "1.25rem", fontFamily:"Texta-book, Helvetica, Arial, 'sans-serif'"}}>
                      {csaVendorInfo?.publicWebsite}
                    </Typography>
                  </Box>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={5} xl={5} >
              {Object.keys(csaVendorInfo).length > 0 && csaVendorInfo?.publicPhoto && (
                <img src={csaVendorInfo?.publicPhoto} alt='Farm Image'  style={{ backgroundColor: "#fff", padding: '0.25rem', border: "1px solid #dee2e6" , alignItems:'center', width: "200px",height: "150px"}} />
              )}
            </Grid>
          </Grid>
        </Grid>
        <Box sx={{ padding: '10px', background: '#eeeeee', border: '1px solid #CCCCCC', borderTop: 'none', display: 'flex', justifyContent: 'flex-end', height: '80px' }}>
          <Button  onClick={(e) => { //disabled={buttonDisable}
             e.preventDefault();
             if (selectedVendor?.name) {
               props.setCSAFormValidate((prevState)=>({
                 ...prevState,
                 farm_info: true
               }));
              const farmInfo = {
                "farmDetails": {
                "farmName": selectedVendor?.name,
                "vendorId": selectedVendor?.id,
                "phoneNumber": props.csaSignup?.csaVendorInfo?.csaVendorInfo?.publicMobile,
                "email": props.csaSignup?.csaVendorInfo?.csaVendorInfo?.publicEmail,
                "isHIPVendor": selectedVendor?.isHIPVendor
                }
              };
               props.setFarmInfo(farmInfo);
               props.setActiveTab("menuStep2");
             } else {
               setIsError(true);
             } //backgroundColor: buttonDisable ? '#bfdad3' : '#006E52 !important'
           }} sx={{ backgroundColor:'#006E52 !important', color: 'white', height: '50px', width: '120px', padding: '10px', marginLeft: '10px',
                    '&:focus-visible': {
                            outline: '2px solid white',   
                            outlineOffset: '2px',
                            boxShadow: '0 0 0 4px black', 
                    }
            }}>
           {language.Next} <ArrowForwardIosIcon />
          </Button>
        </Box>
      </Box>
    </Grid>

  )
}

FarmInfocomponent.propTypes = {
  setActiveTab: PropTypes.func.isRequired,
  getCsaVendorList: PropTypes.func.isRequired,
  getVendorInfo: PropTypes.func.isRequired,
  csaSignup: PropTypes.object.isRequired,
  activeMenu: PropTypes.object,
  handleUpdate: PropTypes.func,
  setCSAFormValidate: PropTypes.func.isRequired,
  setFarmInfo: PropTypes.func,
  farmInfo: PropTypes.object,
  setVendorChange: PropTypes.func,
  signupLanguage: PropTypes.object,
}

function mapDispatchToProps(dispatch) {
  return {
    getCsaVendorList: (payload) => dispatch(actionType.getCsaVendorList(payload)),
    getVendorInfo: (payload) => dispatch(actionType.getVendorInfo(payload))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FarmInfocomponent);







